import Home from './pages/home';
import Development from './pages/development';
import Art from './pages/art';
import Management from './pages/management';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/web-development",
    element: < Development />
  },
  {
    path: "/art-digital-media",
    element: <Art />
  },
  {
    path: "/product-owner-project-management",
    element: <Management />
  },
]);


ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);